import React, { Component } from 'react'

import withApolloClient from '../../withApolloClient'
import { Container, Row, Col } from 'reactstrap'
import ReservationsList from '../ReservationsList'
import '../CarsList.css'
import ReservationsListHeader from "../ReservationsListHeader"
import { buildPresets } from '../../Filters/presetFilters'

export const PRESETS = buildPresets([
    { fieldName: "status", filterType: "equal", filterValues: "Open", editable: false, visible: false },
    { fieldName: "car", filterType: "is_not_null", filterValues: null, editable: false, visible: false },
])

class ReservedCarsContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isReady: null,
            driverType: null,
            searchTerm: "",
            showAllFilters: false,
            selectionRange: [{ startDate: new Date(), endDate: null, key: 'selection' }],
            filterValues: {
                orderBy: ["-driver__in_office", "pickup_date"]
            },
            selectedDrivers: [],
            refetchReservations: false,
            presets: PRESETS,
            defaultPresets: PRESETS,
        }
    }

    setPresets = (presets) => this.setState({ presets })

    updateOrder = (string) => {
        let order = [...this.state.filterValues.orderBy]
        if (!order.includes(string) && !order.includes("-" + string)) {
            order = [order.find(item => item.includes("-driver__in_office")), string]
        } else {
            let index = order.indexOf(string)
            if (order.indexOf(string) > -1) {
                order[index] = "-" + string
            } else {
                index = order.indexOf("-" + string)
                index > -1 && (order[index] = string)
            }
        }
        this.setState({ filterValues: { ...this.state.filterValues, orderBy: order } })
    }

    render() {
        return (
            <Container fluid className=" ReservationsListContainer">
                <ReservationsListHeader
                    activeTab="active"
                    filterValues={this.state.filterValues}
                    setFilterValues={(filterValues) => this.setState({ filterValues })}
                    selectedDrivers={this.state.selectedDrivers} location={this.props.location} history={this.props.navigate}
                    resetSelectedDrivers={() => this.setState({ selectedDrivers: [] })}
                    refetchQuery={() => this.setState({ refetchReservations: !this.state.refetchReservations })}
                    presets={this.state.presets}
                    setPresets={this.setPresets}
                    defaultPresets={this.state.defaultPresets}
                />
                <Row>
                    <Col sm="12">
                        <ReservationsList
                            currentUser={this.props.currentUser}
                            orderBy={this.state.filterValues && this.state.filterValues.orderBy ? this.state.filterValues.orderBy : null}
                            updateOrder={this.updateOrder}
                            searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                            selectedTab="active"
                            presets={this.state.presets}
                            selectedDrivers={this.state.selectedDrivers}
                            setSelectedDrivers={(selectedDrivers) => this.setState({ selectedDrivers })}
                            refetchReservations={this.state.refetchReservations}
                            setRefetchQuery={() => this.setState({ refetchReservations: !this.state.refetchReservations })}
                            reservationPickupStates={this.props.reservationPickupStates}
                        />
                    </Col>
                </Row>
            </Container>
        )
    }
}

//-----------------------------------
export default withApolloClient(ReservedCarsContainer)